var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright",class:{'is-fixed': _vm.fixed}},[_vm._v("\n  —京东金融"),_vm._l((_vm.copyrightList),function(item){return [_c('img',{attrs:{"src":require("@/assets/icon-close.png")}}),_vm._v(_vm._s(item))]}),_vm._v("联合出品—\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }